import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'or',
    fullName: 'Odia',
    nativeName: 'ଓଡ଼ିଆ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ଆଶ୍ଚର୍ଯ୍ୟଜନକ କିଛି ଆସୁଛି |",
    landing_subtitle: "ArgVoid ହେଉଛି ଏକ ଆପ୍ ଏବଂ ଖେଳ ବିକାଶ ଷ୍ଟୁଡିଓ | ରୁହନ୍ତୁ, ନୂତନ ଜିନିଷ ଶୀଘ୍ର ଆସିବ!",
    select_language: "ଭାଷା ଚୟନ କରନ୍ତୁ |",
    search_placeholder: "ଭାଷା ଖୋଜ ...",
    terms_title: "ସେବା ସର୍ତ୍ତାବଳୀ",
    policy_title: "ଗୋପନୀୟତା ନୀତି",
    cookies_title: "କୁକି ନୀତି |",
    terms_content: `
        <strong>1 ସର୍ତ୍ତଗୁଡିକ </strong><br> ର ଗ୍ରହଣ
        ArgVoid କୁ ଆକସେସ୍ କରି, ଏହି ସେବା ସର୍ତ୍ତାବଳୀ ଗ୍ରହଣୀୟ | ଯଦି ଏହି ସର୍ତ୍ତାବଳୀ ସହମତ ନୁହେଁ, ସେବାଟି ବ୍ୟବହାର କରାଯିବା ଉଚିତ ନୁହେଁ | <br><br> |

        <strong>2 ପ୍ଲାଟଫର୍ମ ବ୍ୟବହାର </strong><br> |
        ସୂଚନାଯୋଗ୍ୟ ଏବଂ ସୃଜନଶୀଳ ଉଦ୍ଦେଶ୍ୟ ପାଇଁ ArgVoid ଏବଂ ଏହାର ପ୍ରୟୋଗଗୁଡ଼ିକ “ଯେପରି” ପ୍ରଦାନ କରାଯାଇଛି | ସେବାଟି କେବଳ ଆଇନଗତ ଉଦ୍ଦେଶ୍ୟରେ ବ୍ୟବହୃତ ହେବା ଜରୁରୀ | <br><br> |

        <strong>3 ନିଷେଧ ଆଚରଣ </strong><br> |
        ସାଇଟ୍ ଦୁର୍ବଳତାକୁ ବ୍ୟବହାର କରିବା, ସ୍ପାମ୍ କରିବା, କିମ୍ବା ଭିତ୍ତିଭୂମିରେ ଅନଧିକୃତ ପ୍ରବେଶ ଚେଷ୍ଟା କରିବା ନିଷେଧ | <br><br>

        <strong>4 ପ୍ରତ୍ୟାଖ୍ୟାନ </strong><br> |
        ପ୍ଲାଟଫର୍ମ ଏବଂ ସେବାଗୁଡିକ ବିନା ବିଜ୍ଞପ୍ତିରେ ଯେକ time ଣସି ସମୟରେ ପରିବର୍ତ୍ତିତ ହୋଇପାରେ | ସେବାର ଅପଟାଇମ୍ କିମ୍ବା ଉପଲବ୍ଧତା ବିଷୟରେ କ No ଣସି ୱାରେଣ୍ଟି ପ୍ରଦାନ କରାଯାଇ ନାହିଁ |
    `,
    policy_content: `
        <strong>1 ସୂଚନା ସଂଗ୍ରହ </strong><br> |
        ପ୍ଲାଟଫର୍ମ ଏହି ସମୟରେ ଉପଭୋକ୍ତା ପ୍ରାମାଣିକିକରଣ କିମ୍ବା ଖାତା ସୃଷ୍ଟି ଆବଶ୍ୟକ କରେ ନାହିଁ | କ personal ଣସି ବ୍ୟକ୍ତିଗତ ଚିହ୍ନଟକାରୀ ସୂଚନା (ଯେପରିକି ନାମ କିମ୍ବା ଇମେଲ୍ ଠିକଣା) ପରିଦର୍ଶକମାନଙ୍କଠାରୁ ସକ୍ରିୟ ଭାବରେ ସଂଗୃହିତ ହୁଏ ନାହିଁ | <br><br> |

        <strong>2 Data</strong><br> ବ୍ୟବହାର କରନ୍ତୁ |
        ମ traffic ଳିକ, ଅଜ୍ଞାତ ଆନାଲିଟିକ୍ସ ସାଇଟ୍ ଟ୍ରାଫିକ୍ ବୁ understand ିବା ଏବଂ ପ୍ରୟୋଗଗୁଡ଼ିକର ଉନ୍ନତି ପାଇଁ ସଂଗ୍ରହ କରାଯାଇପାରେ | ଏହି ତଥ୍ୟ ବ୍ୟକ୍ତିଗତ ଉପଭୋକ୍ତା ପରିଚୟ ସହିତ ସଂଯୁକ୍ତ ନୁହେଁ | <br><br> |

        <strong>3 ତୃତୀୟ-ପକ୍ଷ ସେବା </strong><br> |
        ହୋଷ୍ଟିଂ ଏବଂ ଆନାଲିଟିକ୍ସ ସେବା ପାଇଁ ତୃତୀୟ-ପକ୍ଷ ପ୍ରଦାନକାରୀଙ୍କୁ ବ୍ୟବହାର କରାଯାଇପାରେ | ଏହି ସମ୍ପୃକ୍ତ ପ୍ରଦାନକାରୀଙ୍କ ଗୋପନୀୟତା ଅଭ୍ୟାସ ସେମାନଙ୍କ ଭିତ୍ତିଭୂମିରେ ପ୍ରକ୍ରିୟାକୃତ ଅଜ୍ଞାତ ତଥ୍ୟକୁ ପରିଚାଳନା କରେ | <br><br> |

        <strong>4 ଡାଟା ସୁରକ୍ଷା </strong><br> |
        ପ୍ଲାଟଫର୍ମର ସୁରକ୍ଷା ପାଇଁ ଯୁକ୍ତିଯୁକ୍ତ ସୁରକ୍ଷା ବ୍ୟବସ୍ଥା କାର୍ଯ୍ୟକାରୀ କରାଯାଏ | ତଥାପି, ଇଣ୍ଟରନେଟରେ ପ୍ରସାରଣର କ method ଣସି ପଦ୍ଧତି ସଂପୂର୍ଣ୍ଣ ସୁରକ୍ଷିତ ନୁହେଁ | <br><br> |
    `,
    cookies_content: `
        <strong>1 କୁକିଜ୍ ଏବଂ ଲୋକାଲ୍ ଷ୍ଟୋରେଜ୍ କ’ଣ? </strong><br> |
        କୁକିଜ୍ ଏବଂ ବ୍ରାଉଜର୍ ଲୋକାଲ୍ ଷ୍ଟୋରେଜ୍ ହେଉଛି ଭ୍ରମଣରେ ବିନ୍ୟାସ ପସନ୍ଦକୁ ମନେ ରଖିବା ପାଇଁ ଡିଭାଇସରେ ଗଚ୍ଛିତ ଛୋଟ ଡାଟା ଫାଇଲ୍ | <br><br> |

        <strong>2 ବ୍ୟବହାର ଉଦ୍ଦେଶ୍ୟ </strong><br> |
        ବିନ୍ୟାସ ସେଟିଂସମୂହକୁ ସଂରକ୍ଷଣ କରିବା ପାଇଁ ବ୍ରାଉଜର୍ ଲୋକାଲ୍ ଷ୍ଟୋରେଜ୍ କଠୋର ଭାବରେ ବ୍ୟବହୃତ ହୁଏ, ଯେପରିକି: <br> |
        - ଭାଷା ପସନ୍ଦ <br> |
        - ଉପଭୋକ୍ତା ଇଣ୍ଟରଫେସ୍ ବିନ୍ୟାସକରଣ (ଯଥା, ଲେଆଉଟ୍ କିମ୍ବା ଥିମ୍ ସେଟିଂସମୂହ) <br> |
        - ଅସ୍ଥାୟୀ ପ୍ରୟୋଗ cache<br><br> |

        <strong>3 କ No ଣସି ଟ୍ରାକିଂ </strong><br> ନାହିଁ |
        ବିଜ୍ଞାପନ କିମ୍ବା ତୃତୀୟ-ପକ୍ଷ ଟ୍ରାକିଂ ଉଦ୍ଦେଶ୍ୟରେ କୁକିଜ ଏବଂ ସ୍ଥାନୀୟ ଷ୍ଟୋରେଜ୍ ବ୍ୟବହୃତ ହୁଏ ନାହିଁ | ସମସ୍ତ ସଂରକ୍ଷିତ ତଥ୍ୟ ପ୍ଲାଟଫର୍ମର ମୂଳ କାର୍ଯ୍ୟକାରିତା ପାଇଁ କଠୋର ଅଟେ | <br><br> |

        <strong>4 ନିୟନ୍ତ୍ରଣ </strong><br> |
        ବ୍ରାଉଜର୍ ସେଟିଙ୍ଗ୍ ମାଧ୍ୟମରେ ଯେକ time ଣସି ସମୟରେ ବ୍ରାଉଜର୍ ଡାଟା ସଫା ହୋଇପାରିବ, ଯାହା କ local ଣସି ସ୍ଥାନୀୟ ବିନ୍ୟାସକୁ ପୁନ res ସେଟ୍ କରିବ |
    `,
    cookie_consent_text: "ୱେବସାଇଟ୍ କାର୍ଯ୍ୟଗୁଡିକ ସଠିକ୍ ଭାବରେ ନିଶ୍ଚିତ କରିବାକୁ ଆମେ ମ basic ଳିକ କୁକିଜ୍ ବ୍ୟବହାର କରୁ, ଯେପରିକି ଆପଣଙ୍କର ଅଧିବେଶନକୁ ସକ୍ରିୟ ରଖିବା, ଆପଣଙ୍କର ଭାଷା ପସନ୍ଦକୁ ସଂରକ୍ଷଣ କରିବା ଏବଂ ଅନ୍ୟାନ୍ୟ କଷ୍ଟମ୍ ବିନ୍ୟାସକରଣ |",
    read_policy: "କୁକି ନୀତି ପ Read ନ୍ତୁ |",
    support_title: "ସମର୍ଥନ ଯୋଗାଯୋଗ କରନ୍ତୁ |",
    support_subject_label: "ବିଷୟ",
    support_message_label: "ବାର୍ତ୍ତା |",
    support_submit_button: "ବାର୍ତ୍ତା ପଠାନ୍ତୁ |",
    support_hint: "ଟିପନ୍ତୁ: ବାର୍ତ୍ତା ପଠାଇବା ପାଇଁ ଏହା ଆପଣଙ୍କର ଡିଫଲ୍ଟ ଇମେଲ୍ ପ୍ରୟୋଗ ଖୋଲିବ |",
    support_success_msg: "ଆପଣଙ୍କର ଇମେଲ୍ ଆପ୍ ଖୋଲିବା ...",
    support_error_msg: "ବାର୍ତ୍ତା ପଠାଇବାରେ ବିଫଳ | ଦୟାକରି ପରେ ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ |",
    explorer_title: "ଏକ୍ସପ୍ଲୋରର୍",
    history_title: "ଇତିହାସ",
    animation_title: "ଆନିମେସନ୍",
    config_title: "ବିନ୍ୟାସ",
    tool_mouse: "ଚୟନ କରନ୍ତୁ (Ctrl + M)",
    tool_brush: "ବ୍ରଶ୍ (Ctrl + B)",
    tool_brush_mode: "ଟୋଗଲ୍ ମୋଡ୍ (କଠିନ / ସଫା)",
    tool_eraser: "ଇରେଜର (Ctrl + E)",
    tool_brush_size: "ବ୍ରଶ୍ ସାଇଜ୍ ଆଡଜଷ୍ଟ୍ କରନ୍ତୁ |",
    tool_bucket: "ପୁରଣ କରନ୍ତୁ (Ctrl + F)",
    tool_eyedropper: "ଚକ୍ଷୁ",
    tool_grid: "ଗ୍ରୀଡ୍ (Ctrl + Shift + B)",
    tool_rotate: "ଘୂର୍ଣ୍ଣନ କରନ୍ତୁ (Ctrl + Shift + R)",
    tool_flip_h: "ଫ୍ଲିପ୍ H (Ctrl + Shift + H)",
    tool_flip_v: "ଫ୍ଲିପ୍ V (Ctrl + Shift + V)",
    tool_transpose: "ଟ୍ରାନ୍ସପୋଜ୍ (Ctrl + Shift + T)",
    label_width: "ମୋଟେଇ",
    label_height: "ଉଚ୍ଚତା |",
    label_frames: "ଫ୍ରେମ୍ ସଂଖ୍ୟା",
    label_animation: "ଆନିମେସନ୍ ଶ Style ଳୀ",
    label_background_color: "ପୃଷ୍ଠଭୂମି ରଙ୍ଗ |",
    label_interval: "ବ୍ୟବଧାନ",
    tool_anim_config: "ଆନିମେସନ୍ ବିନ୍ୟାସକରଣ |",
    label_new_width: "ନୂତନ ଓସାର |",
    label_new_height: "ନୂତନ ଉଚ୍ଚତା |",
    label_apply: "ପ୍ରୟୋଗ କରନ୍ତୁ |",
    label_colors: "ରଙ୍ଗଗୁଡିକ |",
    label_size: "ଆକାର |",
    label_tolerance: "ସହନଶୀଳତା |",
    val_horizontal: "ଭୂସମାନ୍ତର",
    val_vertical: "ଭୂଲମ୍ବ |",
    val_sequence: "କ୍ରମ |",
    val_bounce: "ବାଉନ୍ସ |",
    val_random: "ଅନିୟମିତ |",
    val_solid: "କଠିନ |",
    val_clear: "ସଫା",
    action_add_sheet: "ନୂତନ ସିଟ୍ |",
    action_import: "ଆମଦାନି କରନ୍ତୁ |",
    action_export: "ରପ୍ତାନି କରନ୍ତୁ |",
    action_sort_projects: "ସର୍ଟ କରନ୍ତୁ |",
    sort_date_old: "ସର୍ବ ପୁରାତନ",
    sort_date_new: "ନୂତନ ପ୍ରଥମ",
    sort_name_az: "ନାମ (A-Z)",
    sort_name_za: "ନାମ (Z-A)",
    action_new_sprite: "ନୂଆ ସ୍ପ୍ରିଟ୍ |",
    action_new_project: "ନୂତନ ପ୍ରକଳ୍ପ",
    modal_save_all_title: "ସମସ୍ତ ପରିବର୍ତ୍ତନ ସଞ୍ଚୟ କରନ୍ତୁ |",
    modal_save_all_desc: "ସଞ୍ଚୟ କରିବାକୁ ସମ୍ପତ୍ତି ଚୟନ କରନ୍ତୁ:",
    modal_save_selected: "ମନୋନୀତ ସଞ୍ଚୟ କରନ୍ତୁ |",
    action_saved: "ସଞ୍ଚୟ ହୋଇଛି |",
    modal_create_sprite_title: "ନୂତନ ସ୍ପ୍ରିଟ୍ ସୃଷ୍ଟି କରନ୍ତୁ |",
    modal_create_project_title: "ନୂତନ ପ୍ରୋଜେକ୍ଟ ସୃଷ୍ଟି କରନ୍ତୁ |",
    modal_add_sheet_title: "ନୂତନ ସିଟ୍ ଯୋଡନ୍ତୁ |",
    modal_rename_sheet_title: "ଶୀଟ୍ ନାମ ପରିବର୍ତ୍ତନ କରନ୍ତୁ |",
    modal_rename_sprite_title: "ସ୍ପ୍ରିଟ୍ ନାମ ପରିବର୍ତ୍ତନ କରନ୍ତୁ |",
    modal_delete_sprite_title: "ସ୍ପ୍ରିଟ୍ ଡିଲିଟ୍ କରନ୍ତୁ |",
    modal_delete_project_title: "ପ୍ରୋଜେକ୍ଟ ବିଲୋପ କରନ୍ତୁ |",
    modal_delete_sheet_title: "ସିଟ୍ ଡିଲିଟ୍ କରନ୍ତୁ |",
    placeholder_sprite_name: "ନାମ",
    placeholder_project_name: "ନାମ",
    placeholder_sheet_name: "ନାମ",
    placeholder_new_name: "ନୂତନ ନାମ",
    action_create: "ସୃଷ୍ଟି କରନ୍ତୁ |",
    action_add: "ଯୋଡନ୍ତୁ |",
    action_rename: "ନାମ ପରିବର୍ତ୍ତନ କରନ୍ତୁ |",
    action_duplicate: "ନକଲ",
    action_delete: "ବିଲୋପ କରନ୍ତୁ |",
    action_cancel: "ବାତିଲ୍ କରନ୍ତୁ |",
    confirm_delete_sprite: "ଆପଣ ନିଶ୍ଚିତ କି ଆପଣ ଏହି ସ୍ପ୍ରିଟ୍ ବିଲୋପ କରିବାକୁ ଚାହୁଁଛନ୍ତି କି?",
    confirm_delete_project: "ଆପଣ ନିଶ୍ଚିତ କି ଆପଣ ଏହି ପ୍ରକଳ୍ପ ବିଲୋପ କରିବାକୁ ଚାହୁଁଛନ୍ତି? ସମସ୍ତ ସ୍ପ୍ରିଟ୍ସ ଅପସାରିତ ହେବ |",
    confirm_delete_sheet: "ଆପଣ ନିଶ୍ଚିତ କି ଆପଣ ଏହି ସିଟ୍ ଡିଲିଟ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି କି?",
    err_select_sprite: "ଦୟାକରି ପ୍ରଥମେ ଏକ ସ୍ପ୍ରିଟ୍ ଚୟନ କରନ୍ତୁ |",
    err_select_project: "ଦୟାକରି ପ୍ରଥମେ ଏକ ପ୍ରୋଜେକ୍ଟ ବାଛନ୍ତୁ |",
    err_name_empty: "ନାମ ଖାଲି ହୋଇପାରିବ ନାହିଁ |",
    err_sprite_exists: "ସେହି ନାମ ସହିତ ଏକ ସ୍ପ୍ରିଟ୍ ପୂର୍ବରୁ ବିଦ୍ୟମାନ ଅଛି |",
    err_project_exists: "ସେହି ନାମ ସହିତ ଏକ ପ୍ରୋଜେକ୍ଟ ପୂର୍ବରୁ ବିଦ୍ୟମାନ ଅଛି |",
    err_no_content: "ସଞ୍ଚୟ କରିବାକୁ କ content ଣସି ବିଷୟବସ୍ତୁ ନାହିଁ |",
    err_no_changes: "ସଞ୍ଚୟ କରିବାକୁ କ changes ଣସି ପରିବର୍ତ୍ତନ ନାହିଁ |",
    err_delete_last_sheet: "ଶେଷ ସିଟ୍ ବିଲୋପ କରିପାରିବ ନାହିଁ |",
    err_extract_frames: "କ any ଣସି ଫ୍ରେମ୍ ବାହାର କରିପାରିବ ନାହିଁ |",
    err_indexeddb: "ସ୍ଥାନୀୟ ଭାବରେ ସଞ୍ଚୟ କରିବାରେ ବିଫଳ | ଆପଣଙ୍କର ବ୍ରାଉଜର୍ ଇଣ୍ଡେକ୍ସଡ୍ DB କୁ ସମର୍ଥନ କରିନପାରେ |",
    msg_upload_success: "ସଫଳ ଅପଲୋଡ୍ କରନ୍ତୁ: {0}",
    msg_upload_failed: "ଅପଲୋଡ୍ ବିଫଳ: {0}",
    msg_save_success: "ସଫଳ ସଞ୍ଚୟ କରନ୍ତୁ |",
    msg_saving: "ସଞ୍ଚୟ ...",
    msg_multi_save_result: "{0} ସମ୍ପତ୍ତି ସଞ୍ଚୟ ହୋଇଛି | {1} ବିଫଳତା |",
    menu_title: "ମେନୁ",
    menu_save: "ସଞ୍ଚୟ କରନ୍ତୁ |",
    menu_save_all: "ସମସ୍ତ ସଞ୍ଚୟ କରନ୍ତୁ |",
    menu_support: "ସମର୍ଥନ ଯୋଗାଯୋଗ କରନ୍ତୁ |",
    label_local_storage: "ସ୍ଥାନୀୟ ଭଣ୍ଡାର |",
    label_sign_in: "ସାଇନ୍ ଇନ୍ କରନ୍ତୁ |",
    modal_export_title: "ରପ୍ତାନି ସ୍ପ୍ରିଟ୍ |",
    label_filename: "ଫାଇଲନାମ",
    label_format: "ଫର୍ମାଟ୍",
    action_export_confirm: "ରପ୍ତାନି କରନ୍ତୁ |",
};

export default translations;
